export default {
  shippingShoiceSetting: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005FD","发运方式设置") /* "发运方式设置" */
};
